export default function getComponentClasses(baseClass, variations = []) {
    let result = baseClass;

    if (variations.length) {
        variations.forEach(function(name) {
            result += ` ${baseClass}--${name}`;
        });
    }

    return result;
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/app/getComponentClasses.js